module.exports = __webpack_public_path__ + "static/media/loginImage.00fb75bc.svg";